import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1, 2);
      if (currentPage > 3) pages.push('...');
      if (currentPage > 2 && currentPage < totalPages - 1) pages.push(currentPage);
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages - 1, totalPages);
      // Deduplicate
      return [...new Set(pages)];
    }
    return pages;
  };

  const pageNumbers = getPageNumbers();

  const btnSx = (isActive) => ({
    minWidth: 36,
    height: 36,
    borderRadius: 2,
    fontSize: '0.875rem',
    fontWeight: isActive ? 600 : 400,
    color: isActive ? '#fff' : 'text.secondary',
    bgcolor: isActive ? '#1B2A3D' : 'transparent',
    border: isActive ? 'none' : '1px solid #E5E7EB',
    '&:hover': {
      bgcolor: isActive ? '#1B2A3D' : '#F3F4F6',
    },
  });

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mt: 4 }}>
      <Button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        startIcon={<ChevronLeftIcon />}
        sx={{
          fontSize: '0.875rem',
          color: 'text.secondary',
          fontWeight: 400,
          '&:hover': { bgcolor: '#F3F4F6' },
        }}
      >
        Previous
      </Button>

      {pageNumbers.map((page, idx) =>
        page === '...' ? (
          <Typography key={`ellipsis-${idx}`} sx={{ px: 1, color: 'text.secondary' }}>
            ...
          </Typography>
        ) : (
          <Button
            key={page}
            onClick={() => onPageChange(page)}
            sx={btnSx(page === currentPage)}
          >
            {page}
          </Button>
        )
      )}

      <Button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        endIcon={<ChevronRightIcon />}
        sx={{
          fontSize: '0.875rem',
          color: 'text.secondary',
          fontWeight: 400,
          '&:hover': { bgcolor: '#F3F4F6' },
        }}
      >
        Next
      </Button>
    </Box>
  );
};

export default Pagination;
